import request from './request'

export function fetchPageSections (params = {}) {
  return request.get('/page-sections', { params })
}

export function createPageSection (payload) {
  return request.post('/page-sections', payload)
}

export function updatePageSection (id, payload) {
  return request.put(`/page-sections/${id}`, payload)
}

export function deletePageSection (id) {
  return request.delete(`/page-sections/${id}`)
}
